<template>
    <ai-tree-node-load :meta="meta" :row-expanding-call-back="rowExpandingCallBack" />
</template>

<script setup>
import AiTreeNodeLoad from '@/components/ai-tree-node-load/ai-tree-node-load.vue';
import { ref } from 'vue';

const meta = ref({
    api: 'demo./demo-ai-tree-node-load1/data/get',
    keyExp: 'id_demo_tree',
    keyParent: 'id_parent',
    pathField: 'path',
    rootId: null,
    columns: [
        {
            index: 3,
            field: 'name',
            caption: 'Name',
            id: 65,
            parent_id: null,
            visible: true,
            can_visible_change: true,
            fixed: false,
            data_type: 'string',
            width: 100,
            group_index: null,
        },
        {
            index: 9,
            field: 'dt',
            caption: 'Дата',
            id: 21,
            parent_id: null,
            data_type: 'date',
            format: 'dd.MM.yyyy',
        },
    ],
    fields: ['name', 'dt'],
    level: 1,
    likes: [],
    sort: {
        field: 'name',
        order: 'asc',
    },
});
const rowExpandingCallBack = async e => {
    console.log('e', e);
};
</script>
<script>
export default {
    name: 'demo-ai-tree-node-load1',
};
</script>

<style scoped></style>
